import React from 'react';
import { useNavigate } from 'react-router-dom';
import Spinner from './components/Spinner';
import { consumeReturnTo } from '../utils/sessionUtils';

const LoginYoutubeOnProgress = ({ loginFunc }) => {
    const navigate = useNavigate();
    // The OAuth `code` is a single-use value consumed on mount. We intentionally
    // run this effect exactly once and pass [] as deps to avoid consuming the
    // code twice under React.StrictMode / re-renders.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    React.useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        const state = params.get('state');
        const error = params.get('error');

        // Google surfaces errors via ?error= (e.g. access_denied). Redirect back to /login with feedback.
        if (error) {
            navigate('/login?ytError=' + encodeURIComponent(error));
            return;
        }

        // Validate the params are strings before hitting the backend.
        if (typeof code !== 'string' || typeof state !== 'string' || !code || !state) {
            navigate('/login?ytError=missing_params');
            return;
        }

        fetch('/login?youtubeCode=' + encodeURIComponent(code) + '&state=' + encodeURIComponent(state), {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(response => {
                if (!response.ok) {
                    // Bubble the HTTP error up so the .catch below handles redirect-on-failure.
                    throw new Error('login_failed_' + response.status);
                }
                return response.json();
            })
            .then(async () => {
                // Esperamos a que se refresque la sesión: si navegamos antes,
                // isAuthenticated sigue en false y ProtectedRoute nos echaría.
                if (loginFunc) {
                    await loginFunc();
                }
                navigate(consumeReturnTo() || '/myAccount');
            })
            .catch(() => {
                navigate('/login?ytError=server_error');
            });
    }, []);
    return (
        <Spinner />
    )
}

export default LoginYoutubeOnProgress;
